import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "../../lib/api";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Input } from "../ui/input";

function Result({ r }) {
  return (
    <div className="panel p-5" data-testid={`research-${r.id}`}>
      <p className="text-[11px] font-mono text-slate-500 mb-2">{r.platform} · {r.model} · {fmtDate(r.created_at)}</p>
      <p className="text-sm text-slate-200 whitespace-pre-wrap">{r.answer}</p>
      {r.citations?.length > 0 && <ol className="mt-3 text-xs space-y-1 list-decimal pl-5">{r.citations.map((c) => <li key={c}><a href={c} target="_blank" rel="noreferrer" className="text-amber-400 break-all">{c}</a></li>)}</ol>}
    </div>
  );
}

export default function ResearchTab({ book }) {
  const [passage, setPassage] = useState("");
  const [platform, setPlatform] = useState("Amazon KDP");
  const [model, setModel] = useState("sonar");
  const [busy, setBusy] = useState(false);
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/research").then((r) => setList(r.data.filter((x) => !x.book_id || x.book_id === book.id))); }, [book.id]);
  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post("/research", { passage, platform, model, book_id: book.id }); setList([data, ...list]); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-4">
      <div className="panel p-5 space-y-3" data-testid="research-form">
        <p className="eyebrow">Web-grounded fact-check · Perplexity</p>
        <Textarea value={passage} onChange={(e) => setPassage(e.target.value)} placeholder="Paste a passage with real-world claims, or a publishing question (e.g. KDP paperback margins for 300 pages)" className="min-h-[110px]" data-testid="research-passage" />
        <div className="flex flex-wrap gap-2">
          <Input value={platform} onChange={(e) => setPlatform(e.target.value)} className="w-56" data-testid="research-platform" />
          <select value={model} onChange={(e) => setModel(e.target.value)} className="h-9 rounded-md bg-slate-900 border border-slate-700 px-2 text-sm" data-testid="research-model"><option value="sonar">Sonar (fast)</option><option value="sonar-pro">Sonar Pro (deeper)</option></select>
          <Button onClick={run} disabled={busy || passage.trim().length < 10} className="ml-auto bg-amber-600" data-testid="research-run"><Search size={14} className="mr-1" />{busy ? "Researching…" : "Research with sources"}</Button>
        </div>
        <p className="text-[11px] text-slate-500">Results cite live web sources; review them — citations are evidence, not a guarantee.</p>
      </div>
      {list.map((r) => <Result key={r.id} r={r} />)}
    </div>
  );
}
